// src/components/ui/layout/Divider/Divider.jsx
import React from 'react';
import { cn } from '../../../../utils/cn';

const Divider = ({
  text,
  className = '',
  lineClassName = '',
  textClassName = '',
  spacing = 'default'
}) => {
  // Spacing configurations
  const spacingConfig = {
    tight: 'my-4',
    default: 'my-8', 
    relaxed: 'my-12'
  };

  if (!text) {
    // Simple line divider
    return (
      <div className={cn(spacingConfig[spacing], className)}>
        <div className={cn(
          "w-full border-t border-slate-700/50",
          lineClassName
        )} />
      </div>
    );
  }

  // Divider with text (like "New partner?" in login)
  return (
    <div className={cn("relative", spacingConfig[spacing], className)}>
      {/* Line */}
      <div className="absolute inset-0 flex items-center">
        <div className={cn(
          "w-full border-t border-slate-700/50",
          lineClassName
        )} />
      </div>
      
      {/* Text */}
      <div className="relative flex justify-center text-sm">
        <span className={cn(
          "px-4 bg-slate-900/80 text-slate-400",
          textClassName
        )}>
          {text}
        </span>
      </div>
    </div>
  );
};

export default Divider;